import { Alert, Grid } from '@mui/material'
import React, { useState } from 'react'
import Nlayout from '../layout/Nlayout'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import axios from 'axios';
import config from '../../config';

function Iniciar(props) {
    const [loginError, setLoginError] = useState('');
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [type, setType] = useState(0);

    const [twoFACode, setTwoFACode] = useState(''); // Código 2FA
    const [showTwoFAStep, setShowTwoFAStep] = useState(false); // Mostrar QR y campo 2FA
    const [twoFAError, setTwoFAError] = useState(''); // Error para 2FA
    const [tokenLogin, setTokenLogin] = useState();
    const [secretKey, setSecretKey] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'password' && value.length > 10) {
            return;
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const [showPassword, setShowPassword] = useState(false);
    const [informacion, setInformacion] = useState()
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handleLogin = async () => {
        if (!formData.username || !formData.password) {
            setLoginError('Por favor, ingresa tu cuenta y contraseña');
            return;
        }
        try {
            const response = await axios.post(`${config.apiBaseUrl}/login`, {
                account: formData.username,
                password: formData.password,
            });
            setInformacion(response)
            if (response.data.success) {
                const { token, oauthEnabled, auth_secret } = response.data;
                console.log('oauthEnabled', oauthEnabled)
                if (oauthEnabled ) {
                    setShowTwoFAStep(true);
                    setTokenLogin(token);
                    setSecretKey(auth_secret);
                    return;
                }
                window.localStorage.setItem("token", token);
                window.localStorage.setItem("account", formData.username);
                window.location.href = "/";
            } else {
                setLoginError('El usuario no existe o la contraseña es incorrecta');
            }
        } catch (error) {
            setLoginError('Error al iniciar sesión');
        }
    };

    const handleVerifyTwoFACode = async () => {
        if (!/^\d{6}$/.test(twoFACode)) {
            setTwoFAError('El código debe tener 6 dígitos');
            return;
        }
        try {
            const response = await axios.post(`${config.apiBaseUrl}/verificarqr`, {
                secretKey: secretKey,
                code: twoFACode,
            });
            if (response.data.isValid) {
                if (type === 0) {
                    // Flujo de login con 2FA
                    window.localStorage.setItem("token", tokenLogin);
                    window.localStorage.setItem("account", formData.username);
                    window.location.href = "/";
                }
            } else {
                setTwoFAError('Código incorrecto. Intenta de nuevo.');
            }
        } catch (error) {
            setTwoFAError('Error en la verificación del código');
        }
    };
    return (
        <Nlayout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>

            <Grid style={{ display: 'flex', flexDirection: 'column', gap: 15, marginTop: 10, padding: 15, borderRadius: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: '100%' }}>
                {
                    !showTwoFAStep &&

                    <div className="auth-content" style={{ width: props?.isMobile ? '100%' :'50%', margin: '0 auto' }}>
                        {loginError && <Alert severity="error">{loginError}</Alert>}
                        <div className="auth-content-input">
                            <p style={{ fontSize: '12px', fontFamily: 'inter', color: 'black' }}>Cuenta*</p>
                            <input
                                name="username"
                                id="identifierId"
                                value={formData.username}
                                onChange={handleChange}
                                type="text"
                            />
                        </div>
                        <div className="auth-content-input">
                            <p style={{ fontSize: '12px', fontFamily: 'inter', color: 'black' }}>Contraseña*</p>
                            <div style={{ position: 'relative', borderRadius: '5px' }}>
                                <input
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    type={showPassword ? 'text' : 'password'}
                                    style={{ paddingRight: '30px', width: '100%' }}
                                />
                                <span
                                    onClick={togglePasswordVisibility}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                                </span>
                            </div>
                            <p style={{ fontSize: '12px', fontFamily: 'inter', textAlign: 'right', color: 'black' }}>
                                {formData.password.length}/10 caracteres
                            </p>
                        </div>
                        <a style={{ padding: 0 }}>
                            <p
                                className="parrafo-auth"
                                style={{
                                    fontSize: "12px",
                                    textAlign: "end",
                                    utilising: "#EB0400",
                                    cursor: "pointer",
                                    color: 'black'
                                }}
                            >
                                ¿Tienes problemas para iniciar sesión?
                            </p>
                        </a>
                        <button onClick={handleLogin} className="auth-button-login">
                            Iniciar Sesión
                        </button>
                    </div>
                }


                {
                    showTwoFAStep &&
                    <div className="auth-content" style={{ width: props?.isMobile ? '100%' :'50%', margin: '0 auto' }}>
                        {twoFAError && <Alert severity="error">{twoFAError}</Alert>}
                        <div className="auth-content-input">
                            <p style={{ fontSize: '12px', fontFamily: 'inter', color: 'black' }}>
                                Ingresa el código de verificación de Google Authenticator
                            </p>
                            <input
                                type="text"
                                pattern="\d{6}"
                                maxLength={6}
                                value={twoFACode}
                                onChange={(e) => setTwoFACode(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <button onClick={handleVerifyTwoFACode} className="auth-button-login">
                            Verificar Código
                        </button>
                        <button
                            onClick={() => setShowTwoFAStep(false)}
                            className="auth-button-login"
                            style={{ marginTop: '10px', background: 'gray' }}
                        >
                            Volver
                        </button>
                    </div>
                }
            </Grid>



        </Nlayout>
    )
}

export default Iniciar